import { type ReactElement, useRef } from 'react'
import cn from 'classnames'
import { useSnapshot } from 'valtio'
import { globalLayoutProxy } from '../../../../proxies/globalLayoutProxy'
import { proxyGlobalAuth } from '../../../../proxies/proxyGlobalAuth'
import { ExpandedDropdown } from './components/ExpandedDropdown'

export function Account (): ReactElement {
  const { accountDropdownExpanded } = useSnapshot(globalLayoutProxy)
  const ref = useRef<HTMLButtonElement>(null)
  const { siteTheme: { topNavBarAccountButtonColors } } = useSnapshot(proxyGlobalAuth)

  const handleClick = (): void => {
    if (!globalLayoutProxy.accountDropdownExpanded) {
      globalLayoutProxy.accountDropdownExpanded = true
    }
  }
  return (
    <>
      <div className="relative inline-block text-left">
        <button
          className={cn(
            topNavBarAccountButtonColors.classes,
            'px-4 py-2 rounded focus:outline-none h-8 flex justify-center items-center font-semibold'
          )}
          type="button"
          ref={ref}
          onClick={handleClick}
        >
          My Account&nbsp;&nbsp;▾
        </button>
        {accountDropdownExpanded && <ExpandedDropdown parentRef={ref} />}
      </div>
    </>
  )
}
